export const getDesignLibrary = (props) => {
    if (process.env.IS_LEGACY) {
        return { '@oneaudi/unified-web-common': (props === null || props === void 0 ? void 0 : props.unifiedWebCommonVersion) || '*' };
    }
    else
        return { '@oneaudi/unified-web-alpha-common': (props === null || props === void 0 ? void 0 : props.unifiedWebAlphaCommonVersion) || '*' };
};
export const getThemeName = (defaultThemeName) => {
    if (process.env.IS_LEGACY) {
        return defaultThemeName || 'light';
    }
    else
        return 'dark';
};
